
import myHeader from "../../components/header.vue"
import myFooter from "../../components/footer.vue"
import {getBizList,getCmsList,getCourseList,getBizListByPost} from "../../api/service.js"
import $ from 'jquery'
import {getExamList} from "../../api/service";
let that;
export default{
    components:{
        myHeader,
        myFooter
    },

    data(){
        return {
          form:{},
          rules: {
            fullName: [
              { required: true, message: '请输入姓名', trigger: 'blur' },
            ],
            mobilePhone: [
              { required: true, message: '请输入手机号码', trigger: 'change' }
            ],
            cooperativePartner: [
              { required: true, message: '请输入申请理由', trigger: 'change' }
            ],
            cooperationReason: [
              { required: true, message: '请输入合作理由', trigger: 'change' }
            ],
          }
        }
    },
    created(){

that=this;
    },
    methods:{
      onSubmit(){
        let url="channelAgent/addChannelAgent";
        getBizListByPost(url,that.form).then(res=>{
          if(res.success){
            this.$message({
              type: 'success',
              message: '保存成功'
            });
          }else{
            this.$message.error(res.message)
          }
        })
      }
    }
}



// WEBPACK FOOTER //
// ./src/pages/enterpriseEdition/channelAgent.js